import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {updateSearchTemplateName} from 'src/openapi/admin/apis/SearchTemplateApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    templateId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRenameTemplate = ({templateId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((templateName: string) => (
        apiDispatch(updateSearchTemplateName({templateId, templateName}))
    ), [templateId, apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
        onFail,
    });
};
